if (!customElements.get('product-card-swatches')) {
  class ProductCardSwatches extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onSwatchClick);
      if (!this.querySelector('.pc-swatches__link--active')) {
        this.querySelector('.pc-swatches__link')?.classList.add('pc-swatches__link--active');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onSwatchClick);
    }

    onSwatchClick = (event) => {
      const link = event.target.closest('.pc-swatches__link');
      if (!link || !this.contains(link)) return;

      const mediaSrc = link.getAttribute('data-media-src');
      const card = this.closest('[data-product-card], .card-wrapper, .card, .lonsdale-pc');
      if (!mediaSrc || !card) return;

      event.preventDefault();

      const media = card.querySelector('.lonsdale-pc__media, .card__media, .card__inner');
      /* Only swap the primary image so secondary hover media stays intact. */
      const image = media?.querySelector('img');
      const srcset = link.getAttribute('data-media-srcset');

      if (image) {
        image.src = mediaSrc;
        if (srcset) {
          image.srcset = srcset;
        } else {
          image.removeAttribute('srcset');
        }
      }

      const href = link.getAttribute('href');
      if (href) {
        card
          .querySelectorAll('[data-card-link], a.full-unstyled-link, a.lonsdale-pc__link')
          .forEach((cardLink) => cardLink.setAttribute('href', href));
      }

      this.querySelectorAll('.pc-swatches__link').forEach((item) => {
        item.classList.toggle('pc-swatches__link--active', item === link);
      });
    };
  }

  customElements.define('product-card-swatches', ProductCardSwatches);
}
